// 上传文件接口
import axios from "axios";
import { getSignNewApi } from '@/apis/oss'
import useFileUtils from './useFileUtils'
import store from "@/store/index";
console.log(store)
// export const ORDER_TABLE_TRADE = `order/tableTrade/${store.getters.getLoginInfo?.userId}/` // 表格下单

const { getExtension } = useFileUtils()
const OverSea = {
  no:0,
  yes:1
}
const BucketNames = {
  "development": {
      [OverSea.no]: 'ckb-service-test',
      [OverSea.yes]: 'test-img-theckb'
  },
  "production": {
      [OverSea.no]: 'ckb-service-prod',
      [OverSea.yes]: 'img-jp-prod-theckb'
  },
  "pre": {
      [OverSea.no]: 'ckb-service-prod',
      [OverSea.yes]: 'img-jp-prod-theckb'
  },
}
// 根据环境获取bucket名称
const getBucketName = (overSea = 0) => {
  // 预发和正式环境用
  console.log(process.env,overSea)
  return BucketNames[process.env.BUCKET_NAME || process.env.NODE_ENV][overSea]
}

// 获取随机文件名称
const getRandomFileName = (params) => {
  const ext = getExtension(params.file.name)
  // ${bizType}_${bizId}_${timeId}.{extName}
  // bizId 业务ID？？
  // timeId 后期改接口，目前用时间戳
  return params.overwrite ? params.fileName : `${params.path}${params.bizType}_${store.getters.getAuthInfo?.userId}_${new Date().getTime()}.${ext}`
}

// interface FAO {
//   file: any
//   path: string // 文件路径 根据模块功能命名   形式：xxx/xxx/   覆盖路径举例：marketing/fileUpload/
//   overwrite?: boolean // 是否覆盖 true 允许 false 禁止
//   fileName?: string // 文件名称 覆盖文件用
//   bizType: string // 业务类型
//   readAuto?: boolean // 前端是否可以直接拼接url读取
// }
export const uploadAliOSS = (params) => {
  return new Promise((resolve, reject) => {
    if (params.overwrite && !params.fileName) {
      reject(new Error('覆盖文件必须添加文件名【fileName】'))
      return
    }
    getSignNewApi({
      bucketName: getBucketName(params.overSea),
      path: params.path,
      type: params.overwrite ? 1 : 0
    }).then((res) => {
      const sign = res
      if (!sign) {
        reject(new Error('当前文件路径不允许覆盖文件'))
        return
      }
      const formData = new FormData()
      const key = getRandomFileName(params)
      formData.append('name', params.file.name)
      // formData.append('Content-Disposition', params.file.name)
      formData.append('key', key)
      formData.append('policy', sign.data.policy)
      formData.append('OSSAccessKeyId', sign.data.accessId)
      formData.append('success_action_status', '200')
      formData.append('signature', sign.data.signature)
      // formData.append('x-oss-object-acl', params.readAuto ? 'public-read' : 'private') // 读取权限
      formData.append('x-oss-object-acl', 'public-read') // 读取权限
      formData.append('x-oss-forbid-overwrite', !!params.overwrite) // 是否允许覆盖
      formData.append('file', params.file) // 文件必须放在最后

      axios({
        method: 'post',
        url: sign.data.host,
        data: formData
      }).then((res) => {
        resolve({ url: `${sign.data.customDomain}/${key}`, key })
      }).catch((error) => {
        reject(error)
      })
    })
  })
}
